export default function BeachVolleyballIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <circle cx="51" cy="12" r="7" fill="#FFD25A" />
      <path d="M0 50h64v14H0z" fill="#EBCB8F" />
      <path d="M0 46c10-3 20 3 32 0s22-3 32 0v4H0z" fill="#3BBCC6" />
      <rect x="30" y="24" width="4" height="30" rx="1.5" fill="#C9CED6" />
      <path d="M12 26h40v12H12z" fill="none" stroke="#2A2F3A" strokeOpacity="0.55" strokeWidth="1.2" strokeDasharray="2 2" />
      <path d="M11 25.5h42" stroke="#FFFFFF" strokeWidth="3" strokeLinecap="round" />
      <path d="M11 25.5h42" stroke="#1D5FA8" strokeWidth="1" strokeLinecap="round" />
      <circle cx="21" cy="13" r="8.5" fill="#FBF8EE" stroke="#2A2F3A" strokeOpacity="0.35" strokeWidth="1" />
      <path d="M13.5 10.5c4-2 10-2 15 1" stroke="#1F5FAF" strokeWidth="2.6" fill="none" strokeLinecap="round" />
      <path d="M14 17c4 1.5 9 1.5 13.5-1.5" stroke="#F4C430" strokeWidth="2.6" fill="none" strokeLinecap="round" />
      <path d="M18 5.5c-2 4-2 11 1 16" stroke="#F4C430" strokeWidth="2" fill="none" strokeLinecap="round" />
    </svg>
  );
}
